module.exports = __webpack_public_path__ + "static/media/logo-welcome.fccecd03.png";